import { useCallback, useEffect, FC, ReactNode } from 'react';

export type ContentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  buttonText: string;
  onButtonClick: () => void;
};

export const ContentModal: FC<ContentModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  buttonText,
  onButtonClick,
}) => {
  const handleOverlayClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="content-modal" onClick={handleOverlayClick} role="dialog" aria-modal="true">
      <div className="content-modal__box">
        <button type="button" className="content-modal__close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <span className="h2-dtm color-black">{title}</span>
        <div className="h4-text color-black content-modal__content">{children}</div>
        <button type="button" className="content-modal__btn" onClick={onButtonClick}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};
